import { useMutation, useQuery } from "@tanstack/react-query";

import {
  getSession,
  sendVerificationOtp,
  signOut,
  verifyEmailOtp,
} from "./api";

export function useSession() {
  return useQuery({
    queryKey: ["session"],
    queryFn: getSession,
    retry: false,
  });
}

export function useSendOtpMutation() {
  return useMutation({
    mutationFn: sendVerificationOtp,
  });
}

export function useVerifyOtpMutation() {
  return useMutation({
    mutationFn: verifyEmailOtp,
    onSuccess: () => {
      getSession().then((data) => {
        if (data?.session) {
          localStorage.setItem("orgId", data.user.organizations[0].id ?? "");
          // Redirect to home page after successful login
          window.location.href = "/";
        }
      });
    },
  });
}

export function useSignOutMutation() {
  return useMutation({
    mutationFn: signOut,
    onSuccess: () => {
      // Clear any cached session data
      window.location.href = "/auth/login";
    },
  });
}
